<template>
  <PageSection
    class="training-section-grid-blocks"
  >
    <template #default>
      <div class="container">
        <div class="grid-wrapper">
          <div
            v-if="leftBlock && leftBlock.length"
            class="left-block"
            :class="{'is-single': leftBlock.length === 1}"
            v-inview-animate:once="{name: 'fade-down', duration: 500, delay: 300}"
          >
            <TrainingSectionGridBlockItem
              v-for="(block, index) in leftBlock"
              :key="`left-block-${index}`"
              :title="block.Title"
              :text="block.Text"
              :background="block.Background"
              :background-mobile="block.BackgroundMobile"
              :theme="block.Theme"
            />
          </div>
          <div
            v-if="rightBlocks && rightBlocks.length"
            class="right-blocks"
            :class="{'is-single': rightBlocks.length === 1}"
            v-inview-animate:once="{name: 'fade-down', duration: 500, delay: 400}"
          >
            <TrainingSectionGridBlockItem
              v-for="(block, index) in rightBlocks"
              :key="`right-block-${index}`"
              :title="block.Title"
              :text="block.Text"
              :background="block.Background"
              :background-mobile="block.BackgroundMobile"
              :theme="block.Theme"
            />
          </div>
        </div>
      </div>
    </template>
  </PageSection>
</template>

<script>
import PageSection from '@/components/PageSection.vue';
import TrainingSectionGridBlockItem from './TrainingSectionGridBlockItem.vue';

export default {
  name: 'TrainingSectionGridBlocks',
  components: {
    PageSection,
    TrainingSectionGridBlockItem,
  },
  props: {
    leftBlock: {
      type: Array,
      default: () => [],
    },
    rightBlocks: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.training-section-grid-blocks {
  :deep(.container) {
    padding-left: 0;
    padding-right: 0;
  }

  .grid-wrapper {
    display: flex;
    width: 100%;

    @include screen("md", max) {
      flex-wrap: wrap;
    }

    @include screen("sm", max) {
      flex-direction: column;
      flex-wrap: nowrap;
    }
  }

  .left-block {
    display: flex;
    flex-direction: column;
    gap: 30px;

    @include wRule(
      width,
      (
        xl: 1092,
        lg: 806,
      )
    );

    @include screen("md", max) {
      width: 100%;
      order: 2;
    }

    @include screen("sm", max) {
      min-height: auto;
    }

    &.is-single {
      :deep(.training-section-grid-block-item) {
        flex: 1;
      }
    }
  }

  .right-blocks {
    display: flex;
    flex-direction: column;
    gap: 30px;
    flex: 1;

    @include screen("md", max) {
      flex-direction: row;
      flex: none;
      width: 100%;
      order: 1;
    }

    @include screen("sm", max) {
      flex-direction: column;
      min-height: auto;
    }

    &.is-single {
      :deep(.training-section-grid-block-item) {
        flex: 1;
      }
    }
  }

  .right-blocks {
    :deep(.training-section-grid-block-item) {
      @include screen("md", max) {
        padding-top: 67px;
        padding-bottom: 67px;
      }

      @include screen("sm", max) {
        padding-top: 100px;
        padding-bottom: 100px;
      }
    }
  }

  .left-block {
    :deep(.training-section-grid-block-item) {
      @include screen("md", max) {
        padding-top: 90px;
        padding-bottom: 90px;
      }

      @include screen("sm", max) {
        padding-top: 100px;
        padding-bottom: 100px;
      }
    }

    :deep(.training-section-grid-block-item .content) {
      @include screen("md", max) {
        max-width: 40%;
      }

      @include screen("sm", max) {
        max-width: 80%;
      }
    }

    :deep(.training-section-grid-block-item .bg-media img) {
      @include screen("md", max) {
        object-position: center bottom;
      }
    }
  }

  .left-block.is-single,
  .right-blocks.is-single {
    :deep(.training-section-grid-block-item) {
      justify-content: flex-end;
    }

    :deep(.training-section-grid-block-item.is-bg .content) {
      margin: 0;
      padding-top: 0;
      padding-right: 0;
      padding-bottom: 0;

      @include wRule(
        padding-left,
        (
          xl: 12%,
          lg: 10%,
          md: 8%,
          sm: 0%,
        )
      );
    }
  }
}
</style>
